import { Outlet } from 'react-router-dom';
import ScrollToTop from '../components/common/ScrollToTop';
import MetaManager from '../components/common/MetaManager';

const AuthLayout = () => {
  return (
    <>
      <MetaManager />
      <Outlet />
      <ScrollToTop />
    </>
  );
};

export default AuthLayout;
